import {apiClient} from '../foundation/apiClient';
import {CartDTO, CheckoutCartDTO, FetchCartDTO, OrderInfo} from './models';

export const getFetchCart = async (fetchCartDTO: FetchCartDTO): Promise<CartDTO> => {
    const data = await apiClient.post('cart/fetch', fetchCartDTO);
    return data.data;
};

export const checkoutCart = async (checkoutCartDTO: CheckoutCartDTO): Promise<OrderInfo> => {
    const data = await apiClient.post('cart/checkout', checkoutCartDTO);
    return data.data;
};
